import heroIMG from '../../assets/images/projects/rock-solid-nutrition/hero.png';

// Майбутні зображення сторінки
import challengeIMG from '../../assets/images/projects/rock-solid-nutrition/challenge.png';
import structureIMG from '../../assets/images/projects/rock-solid-nutrition/structure.png';

import { projectAuthorData } from './projectAuthorData';

export const rockSolidNutritionProject = {
    id: 1,
    slug: 'rock-solid-nutrition',

    label: 'Shopify',
    category: 'Shopify Entwicklung',

    title: 'Rock Solid® Nutrition',

    cardDescription:
        'Shopify-Umsetzung für eine Nutrition-Marke: Produktseiten, Startseite und technische Store-Struktur für den Online-Verkauf.',

    image: heroIMG,
    imageAlt: 'Rock Solid Nutrition Shopify Store Startseite',

    tags: ['Entwicklung', 'Shopify', 'USA'],

    website: 'https://rocksolidnutrition.com/',

    page: {
        seo: {
            title: 'Rock Solid Nutrition — Shopify-Entwicklung für eine Nutrition-Marke | Nexon Digital Studio',

            description:
                'Shopify-Umsetzung für Rock Solid Nutrition mit Produktseiten, Startseite, mobiler Optimierung und technischer Store-Struktur.',
        },

        hero: {
            subtitle:
                'Nexon Digital Studio entwickelt und verbessert Shopify-Shops für kleine Unternehmen, Marken und Online-Händler in Deutschland — klar strukturiert, technisch sauber und auf Online-Verkauf ausgerichtet.',

            title: ['SHOPIFY', 'ENTWICKLUNG'],

            text: 'Shopify-Erstellung, Theme-Anpassung, Relaunch und technische Umsetzung für Unternehmen, die online verkaufen möchten.',

            button: 'Anfrage senden',
        },

        intro: {
            title: 'Rock Solid Nutrition — Shopify-Umsetzung für eine Nutrition-Marke',

            texts: [
                'Für Rock Solid Nutrition wurde ein Shopify-Store technisch umgesetzt und strukturiert aufgebaut. Der Fokus lag auf einer klaren Produktpräsentation, einer verkaufsorientierten Startseite und einer sauberen technischen Grundlage für den Online-Verkauf.',

                'Das Projekt zeigt, wie Nexon Digital Studio Shopify-Shops für Marken im Bereich Nutrition und E-Commerce technisch umsetzt, wichtige Shop-Bereiche strukturiert und bestehende Inhalte in eine nutzbare Shopify-Umgebung überträgt.',
            ],

            meta: [
                {
                    id: 1,
                    title: 'Shopify-Projekt',
                    label: 'Projektart',
                },
                {
                    id: 2,
                    title: 'Nutrition',
                    label: 'Branche',
                },
                {
                    id: 3,
                    title: 'Produktseiten',
                    label: 'Umfang',
                },
                {
                    id: 4,
                    title: 'Konvertierung',
                    label: 'Umfang',
                },
            ],

            image: heroIMG,
            imageAlt: 'Rock Solid Nutrition Shopify Store Startseite',
        },

        challenge: {
            theme: 'dark',

            eyebrow: 'Ausgangssituation',

            title: 'Eine historisch gewachsene Systemlandschaft am Limit',

            text: 'Rock Solid Nutrition benötigte eine technische Shopify-Umsetzung, bei der Produkte übersichtlich präsentiert und wichtige Shop-Bereiche sauber aufgebaut werden. Der Fokus lag auf einer klaren Struktur, mobiler Darstellung und einer nutzbaren Grundlage für den Online-Verkauf.',

            items: [
                {
                    id: 1,
                    text: 'Unklare Struktur für Produktbereiche und Collections',
                },
                {
                    id: 2,
                    text: 'Startseite war nicht ausreichend auf Conversion und Online-Verkauf ausgerichtet',
                },
                {
                    id: 3,
                    text: 'Produktseiten waren unübersichtlich und schwer verständlich aufgebaut',
                },
                {
                    id: 4,
                    text: 'Mobile Darstellung und Nutzerführung funktionierten nicht optimal',
                },
                {
                    id: 5,
                    text: 'Technische Shopify-Struktur war nicht sauber organisiert und schwer wartbar',
                },
                {
                    id: 6,
                    text: 'Es fehlte eine stabile Grundlage für zukünftige Erweiterungen und Optimierungen',
                },
            ],

            image: challengeIMG,
            imageAlt: 'Rock Solid Nutrition Produktbereich Shopify',
        },

        structure: {
            theme: 'light',

            eyebrow: 'Zielsetzung',

            title: 'Eine klare Shopify-Grundlage für den Online-Verkauf schaffen',

            text: 'Ziel des Projekts war es, den Shopify-Store von Rock Solid Nutrition klarer zu strukturieren, Produkte besser zu präsentieren und wichtige Shop-Bereiche technisch sauber umzusetzen. Der Store sollte auf mobilen Geräten verständlich funktionieren und eine stabile Grundlage für weitere Optimierungen bieten.',

            image: structureIMG,
            imageAlt: 'Rock Solid Nutrition Mobile Shopify Store',

            items: [
                {
                    id: 1,
                    title: 'Produktpräsentation',
                    text: 'Übersichtliche Darstellung von Produkten, Produktbereichen und wichtigen Verkaufsflächen im Shopify-Store.',
                },
                {
                    id: 2,
                    title: 'Shop-Struktur',
                    text: 'Klare Struktur für Startseite, Produktseiten, Collections und Navigation, damit Nutzer schneller zu relevanten Produkten finden.',
                },
                {
                    id: 3,
                    title: 'Mobile Darstellung',
                    text: 'Optimierung der mobilen Nutzerführung, damit der Shopify-Shop auch auf Smartphones verständlich und nutzbar bleibt.',
                },
                {
                    id: 4,
                    title: 'Technische Grundlage',
                    text: 'Saubere Shopify-Umsetzung als Basis für spätere Anpassungen, Erweiterungen und technische Verbesserungen.',
                },
            ],
        },

        shopifyImplementation: {
            theme: 'dark',

            eyebrow: 'Warum Nexon Digital Studio',

            title: 'Fokussierte Shopify-Umsetzung statt unnötiger Agenturprozesse.',

            text: 'Für Rock Solid Nutrition lag der Fokus auf einer klaren technischen Shopify-Umsetzung. Nexon Digital Studio unterstützte bei der Struktur des Shopify-Stores, der Produktpräsentation, mobilen Darstellung und technischen Grundlage für den Online-Verkauf',

            items: [
                {
                    id: 1,
                    title: 'Shopify-Expertise',
                    text: 'Technische Umsetzung von Shopify-Stores, Produktseiten, Collections und Theme-Anpassungen.',
                },
                {
                    id: 2,
                    title: 'Klare Verantwortung',
                    text: 'Ein direkter Ansprechpartner, klare Abstimmung und transparente Umsetzungsschritte.',
                },
                {
                    id: 3,
                    title: 'Saubere Store-Struktur',
                    text: 'Aufbau einer verständlichen Shopify-Struktur, die Produkte klar präsentiert und einfach gepflegt werden kann.',
                },
            ],
        },

        implementation: {
            theme: 'light',

            eyebrow: 'Umsetzung',

            title: 'Technische Shopify-Umsetzung für einen klar strukturierten Online-Shop',

            items: [
                {
                    id: 1,
                    eyebrow: 'Shopify-Umsetzung',
                    title: 'Startseite und Store-Struktur',
                    text: 'Die Startseite wurde klar auf Produktpräsentation, Orientierung und Online-Verkauf ausgerichtet. Wichtige Shop-Bereiche wurden technisch sauber in Shopify aufgebaut.',
                },
                {
                    id: 2,
                    eyebrow: 'Produktseiten & Collections',
                    title: 'Übersichtliche Produktbereiche',
                    text: 'Produktseiten und Collection-Seiten wurden so strukturiert, dass Produkte verständlich dargestellt werden und Nutzer schneller zu relevanten Bereichen finden.',
                },
                {
                    id: 3,
                    eyebrow: 'Mobile Optimierung',
                    title: 'Nutzbar auf allen Geräten',
                    text: 'Die mobile Darstellung, Navigation und Nutzerführung wurden geprüft und angepasst, damit der Shopify-Store auch auf Smartphones klar und einfach nutzbar bleibt.',
                },
            ],
        },

        results: {
            theme: 'light',

            eyebrow: 'Ergebnisse',

            title: 'Ein klar strukturierter Shopify-Store für den Online-Verkauf',

            stats: [
                {
                    id: 1,
                    value: '10+',
                    label: 'Store-Bereiche',
                    text: 'Strukturiert und technisch umgesetzt',
                },
                {
                    id: 2,
                    value: '6',
                    label: 'Shopify-Templates',
                    text: 'Für Produktseiten, Collections und zentrale Shop-Bereiche',
                },
                {
                    id: 3,
                    value: '3',
                    label: 'Breakpoints',
                    text: 'Desktop, Tablet und Mobile geprüft',
                },
                {
                    id: 4,
                    value: '100%',
                    label: 'Shopify',
                    text: 'Fokussierte Umsetzung ohne unnötige Systemkomplexität',
                },
            ],

            testimonial: {
                quote: 'Bei diesem Projekt lag der Fokus auf einer klaren Shopify-Struktur, verständlicher Produktpräsentation und einer sauberen technischen Grundlage. Der Store wurde so aufgebaut, dass Produkte besser sichtbar sind und wichtige Shop-Bereiche langfristig gepflegt und erweitert werden können.',

                labelTitle: 'Kommentar-Label:',
                label: 'Kommentar zur Umsetzung',

                author: {
                    ...projectAuthorData,
                    name: 'Dmytro Kiriachek',
                    position: 'CEO Nexon Digital Studio',
                },
            },
        },

        faq: {
            title: 'Häufige Fragen zu diesem Shopify-Projekt',

            items: [
                {
                    id: 1,
                    question: 'Was wurde bei Rock Solid Nutrition umgesetzt?',

                    answer: 'Bei Rock Solid Nutrition lag der Fokus auf Shopify-Umsetzung, Produktpräsentation, Produktseiten, Store-Struktur, mobiler Darstellung und technischer Umsetzung.',
                },
                {
                    id: 2,
                    question: 'Für welche Art von Unternehmen ist dieses Projekt relevant?',

                    answer: 'Das Projekt ist relevant für Nutrition-Marken, Online-Händler und Unternehmen mit umfangreichen Produktkatalogen.',
                },
                {
                    id: 3,
                    question: 'Kann Nexon Digital Studio ähnliche Shopify-Stores verbessern?',

                    answer: 'Ja. Nexon Digital Studio unterstützt Shopify-Stores bei Struktur, Produktpräsentation, Produktseiten, mobiler Optimierung und technischer Umsetzung.',
                },
            ],

            button: {
                text: 'Anfrage senden',
                href: '#contacts',
            },
        },
    },
};
